import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import FilterHeader from "../FilterHeader";
import TabHeaders from "../TabHeaders";
import FeatureRow from "./FeatureRow";
import styles from "./AgentFeatures.module.css";
import { useApi } from "../../../../../../common/hooks";
import { AiFeatureService } from "../../../../../../api";
import { FEATURE_TABS } from "../tabs";
import { setCurrentDsiAgentSubpage } from "../../../../slice/dsi-slice";
import { isNonEmptyArray } from "../../../../../../common/utils";

export default function AgentFeatures() {
	const [search, setSearch] = useState("");
	const [count, setCount] = useState(0);
	const [features, setFeatures] = useState([]);
	const [sortDirection, setSortDirection] = useState("desc");
	const [sortKey, setSortKey] = useState("");
	const { call: getFeatures } = useApi(AiFeatureService.getFeatures);
	const dispatch = useDispatch();
	useEffect(() => {
		setTimeout(() => {
			dispatch(setCurrentDsiAgentSubpage(2));
		}, 300);
	}, [dispatch]);
	useEffect(() => {
		getFeatures({ name: search, direction: sortDirection.toUpperCase() })
			.then((data) => setFeatures(data))
			.catch(console.error);
	}, [getFeatures, search, count, sortDirection]);
	const handleChangeFilters = ({ name }) => {
		setSearch(name);
	};
	const handleRefresh = () => {
		setCount((prev) => prev + 1);
	};
	const rowRenderer = (feat) => <FeatureRow key={feat.featureId} feature={feat} onRefresh={handleRefresh} />;
	const handleClickSort = (newKey) => {
		if (newKey === sortKey) {
			setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
		} else {
			setSortKey(newKey);
			setSortDirection("asc");
		}
	};
	return (
		<div className={styles.main}>
			<FilterHeader actionTitle="dsi.form-studio.criteria.new.button" onChangeFilters={handleChangeFilters} />
			<TabHeaders
				simpleFlex
				hasActions={false}
				sortDirection={sortDirection}
				sortKey={sortKey}
				tabs={FEATURE_TABS}
				onClickSort={handleClickSort}
			/>
			<div className={styles.list}>{isNonEmptyArray(features) && features.map((row) => rowRenderer(row))}</div>
		</div>
	);
}
